import type { ExpertSummary } from "../../api";

type ExpertIdentity = Pick<
  ExpertSummary,
  "monogram" | "color_token" | "display_name"
>;

export function ExpertMark({
  expert,
  size = 36,
  square = true,
  ring = false,
}: {
  expert: ExpertIdentity;
  size?: number;
  square?: boolean;
  ring?: boolean;
}) {
  const c = expert.color_token;
  return (
    <div
      aria-label={expert.display_name}
      title={expert.display_name}
      style={{
        width: size,
        height: size,
        borderRadius: square ? Math.max(4, size * 0.15) : "50%",
        background: `var(--${c}-tint)`,
        color: `var(--${c}-deep)`,
        border: `1px solid color-mix(in oklab, var(--${c}) 35%, transparent)`,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "var(--mono)",
        fontWeight: 600,
        fontSize: Math.round(size * 0.36),
        letterSpacing: "0.02em",
        flexShrink: 0,
        boxShadow: ring
          ? `0 0 0 4px color-mix(in oklab, var(--${c}) 18%, transparent)`
          : "none",
        position: "relative",
        userSelect: "none",
      }}
    >
      {expert.monogram}
    </div>
  );
}
